import Load from 'components/Load';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

export const homescreenMenuRoute: RouteDescriptor = {
  id: 'homescreen.menu',
  path: `${basePath}/more/`,
  label: 'Menu',
  audience: 'both',
  layout: 'navigational',
  module: 'homescreen',
};

export const homescreenHomeRoute: RouteDescriptor = {
  id: 'homescreen.home',
  path: `${basePath}/`,
  label: 'Home',
  audience: 'both',
  layout: 'navigational',
  module: 'homescreen',
};

const AsyncMenuPage = Load(
  () => import(/* webpackChunkName: "menupage" */ './containers/MenuPage'),
);

const AsyncHomePage = Load(
  () => import(/* webpackChunkName: "homepage" */ './HomePage'),
  {},
  true,
);

const AsyncHomeScreen = Load(
  () => import(/* webpackChunkName: "homescreen" */ './HomeScreen'),
  {},
  true,
);

const isApp = isCordova();

export const homescreenRoutes = [
  createNavigationalRoute({
    key: homescreenMenuRoute.id,
    id: homescreenMenuRoute.id,
    path: homescreenMenuRoute.path,
    handle: createRouteHandle(homescreenMenuRoute),
    hideFooter: true,
    showZendesk: false,
    component: AsyncMenuPage,
    showBottomNavigation: true,
    noNavbar: true,
  }),
  createNavigationalRoute({
    key: homescreenHomeRoute.id,
    id: homescreenHomeRoute.id,
    path: homescreenHomeRoute.path,
    handle: createRouteHandle(homescreenHomeRoute),
    component: isApp ? AsyncHomeScreen : AsyncHomePage,
    showSearchInNavbar: false,
    showBottomNavigation: true,
    transparentNavbar: !isApp,
    hideFooter: isApp,
    nonFixedNavbar: isApp,
  }),
];

export const homescreenRouteDescriptors = [
  homescreenMenuRoute,
  homescreenHomeRoute,
];

export default homescreenRoutes;
